export default {"src":"/_next/static/media/AU.3c690555.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};